
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/editorial/fc-fridays",
      function () {
        return require("private-next-pages/editorial/fc-fridays.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/editorial/fc-fridays"])
      });
    }
  